import { IFormOkCancelViewModel } from "./form-ok-cancel/form-ok-cancel.component";

/**
 * 
 */
export interface IFormViewModel {
    title: string;

    type: string;

    okCancelVm: IFormOkCancelViewModel;
}

/**
 * 
 */
export interface IFormElementViewModel {
    elementId: string;
    title: string;
    field: string;

    dataGet: () => any;
    dataSet: (data: any) => void;

    validate?: (vm: IFormElementViewModel) => string[];
}


/**
 * 
 */
export interface IFormElementViewModelOptions {
    title: string;
    helpText?: string;

    isLocked?: boolean;
    isRequired?: boolean;

    hideLabel?: boolean;

    changeValidator?: (v: any) => string;
}

/**
 * 
 */
export class FormElementViewModel {

    /**
     * 
     * @param context 
     * @param field 
     * @param options 
     * @param elementInstance 
     * @returns 
     */
    public static create<typeOfViewModel extends IFormElementViewModel, typeOfOptions extends IFormElementViewModelOptions>(
        context: any, field: string, options: typeOfOptions, elementInstance: number = undefined
    ): typeOfViewModel {
        const ret: IFormElementViewModel = {
            ...options,

            field: field,
            elementId: `${field}-${elementInstance ?? 1}`,

            dataGet: () => {
                const ret = context[field];
                return ret;
            },
            dataSet: (data) => {
                context[field] = data;
            },
        };
        return <any>ret;
    }
}